/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Weighing_Approve_SuccessInputs */

const vi_toast_weighing_approve_success = /** @type {(inputs: Toast_Weighing_Approve_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt phiếu cân`)
};

/**

* @param {Toast_Weighing_Approve_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_weighing_approve_success = /** @type {((inputs?: Toast_Weighing_Approve_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Weighing_Approve_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_weighing_approve_success(inputs)
});